import React from 'react'

export const UsuarioScreen = () => {
  return (
    <div>UsuarioScreen</div>
  )
}
